import { Component, OnInit } from '@angular/core';
import { SharedMarcacaoService } from "../../services/shared-marcacao.service";
import { MarcacaoService } from "../../services/marcacao.service";
import { MarcacaoModel } from "../../models/marcacao.model";

@Component({
  selector: 'app-tabela-consulta',
  templateUrl: './tabela-consulta.component.html',
  styleUrls: ['./tabela-consulta.component.scss']
})
export class TabelaConsultaComponent implements OnInit {
  protected marcacoes: MarcacaoModel[] = [];
  protected marcacaoAtual: MarcacaoModel | undefined;

  constructor(
    private sharedMarcacaoService: SharedMarcacaoService,
    private marcacaoService: MarcacaoService
  ) { }

  ngOnInit() {
    this.sharedMarcacaoService.marcacaoAtual.subscribe(marcacao => {
      if (marcacao) {
        
        if (!this.marcacaoAtual) {
          // Estamos abrindo a página de dados do atendimento pela primeira vez.
          this.marcacaoService.getAllRealizadasBySeqBeneficiario(marcacao.seq_Beneficiario!).subscribe(res => {
            
            // Pega apenas o histórico de finalizados/realizados
            this.marcacoes = res.data
              .map((m: any) => Object.assign(new MarcacaoModel(), m))
              .filter((m: MarcacaoModel) => m.status_Atendimento === 6 || m.status_Atendimento === 7);

            // Adiciona a marcação atual (que pode ser a que está EM ATENDIMENTO) e ordena!
            this.atualizarMarcacaoAtual(marcacao);
          });
        } else {
          // Estamos apenas navegando entre os atendimentos na mesma tela
          this.atualizarMarcacaoAtual(marcacao);
        }

      } else {
        this.marcacoes = [];
        this.marcacaoAtual = undefined;
      }
    });
  }

  atualizarMarcacaoAtual(marcacao: MarcacaoModel | undefined) {
    if (!marcacao) {
      this.marcacaoAtual = undefined;
      return;
    }

    this.marcacaoAtual = marcacao;

    // Procura se o atendimento atual já está na lista
    const index = this.marcacoes.findIndex(m => m.seq_Agenda === marcacao.seq_Agenda);
    
    if (index > -1) {
      // Se já existe, atualiza os dados
      this.marcacoes[index] = this.marcacaoAtual;
    } else {
      // Se não existe, adiciona na lista
      this.marcacoes.push(this.marcacaoAtual);
    }

    // A MÁGICA ACONTECE AQUI: Reordena a lista sempre que algo for adicionado/modificado
    this.ordenarLista();
  }

  private ordenarLista() {
    this.marcacoes.sort((a, b) => {
      
      // REGRA 1: Status 5 (EM ATENDIMENTO) tem prioridade máxima e vai para o topo
      const isA_EmAtendimento = a.status_Atendimento === 5;
      const isB_EmAtendimento = b.status_Atendimento === 5;

      if (isA_EmAtendimento && !isB_EmAtendimento) return -1;
      if (!isA_EmAtendimento && isB_EmAtendimento) return 1;

      // REGRA 2: Se não for "Em atendimento", ordena do MAIS RECENTE para o MAIS ANTIGO (Decrescente)
      try {
        const dataA = new Date(a.data_Agenda);
        dataA.setHours(Math.floor(a.hora_Agenda / 100));
        dataA.setMinutes(a.hora_Agenda % 100);

        const dataB = new Date(b.data_Agenda);
        dataB.setHours(Math.floor(b.hora_Agenda / 100));
        dataB.setMinutes(b.hora_Agenda % 100);

        // dataB - dataA = Ordem decrescente
        return dataB.getTime() - dataA.getTime();
        
      } catch (e) {
        return 0;
      }
    });
  }

  setMarcacaoAtual(marcacao: MarcacaoModel) {
    this.sharedMarcacaoService.setMarcacaoAtual(marcacao);
  }
}